'use client';

import {usePathname, useSearchParams} from 'next/navigation';
import {useEffect, useMemo} from 'react';
import {pageViewed} from 'iq-tracking';

// Query params that should NOT retrigger a page view event.
const IGNORED_PARAMS = new Set(['tab']);

function PageViewTrackerInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const trackedParams = useMemo(() => {
    const filtered = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (!IGNORED_PARAMS.has(key)) filtered.set(key, value);
    });
    return filtered.toString();
  }, [searchParams]);

  useEffect(() => {
    void pageViewed();
  }, [pathname, trackedParams]);

  return null;
}

// Wrapped in a named export so the parent can Suspense-boundary it
// without making the root layout suspendable.
export function PageViewTracker() {
  return <PageViewTrackerInner />;
}
